import {removeAuthTokens, setAuthTokens, setLoginToken} from 'infra/http/utils';
import {HomeEnum, SignInEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {useGetSidebarMutation} from 'presentation/mutation/useGetSidebarMutation';
import {useNavigate} from 'react-router-dom';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {useSetRecoilState} from 'recoil';
import {accountDataStateRefresher} from 'presentation/pages/states';
import {useGetCompanyPortalMutation} from '../mutation/useGetCompanyPortalMutation';

export function useAuthorization() {
	const navigate = useNavigate();
	const {dataHostNameState} = useHostName();
	const setAccountData = useAccountDataStore(state => state.setAccountData);
	const resetAccountData = useAccountDataStore(state => state.resetAccountData);

	const {mutateAsync: getSidebar} = useGetSidebarMutation();
	const {mutateAsync: getCompanyPortal} = useGetCompanyPortalMutation();
	const setAccountDataStateRefresher = useSetRecoilState(accountDataStateRefresher);

	const handleSetLoginToken = async (hash: string) => {
		try {
			const companyPlanCode = dataHostNameState.productCode
				.map(code => code.toString())
				.join(',');
			const beneficiaryData = await getCompanyPortal({hash, companyPlanCode});

			setAccountData({
				logged_user: {
					cdPessoa: beneficiaryData.beneficiary.cdPessoa,
					cdUsuario: beneficiaryData.beneficiary.cdUsuario,
				},
				accessed_user: {
					cdPessoa: beneficiaryData.beneficiary.cdPessoa,
					cdUsuario: beneficiaryData.beneficiary.cdUsuario,
				},
				companyPortal: beneficiaryData.companyPortal,
			});

			setLoginToken(beneficiaryData.login_token);
			setAuthTokens(beneficiaryData.access_token, beneficiaryData.refresh_token);

			const sidebarData = await getSidebar();

			if (!sidebarData) {
				removeAuthTokens();
				resetAccountData();
				setAccountDataStateRefresher(val => val + 1);
			}

			setAccountData({
				beneficiary: sidebarData.beneficiary,
				sidebar: sidebarData.sideBar,
				accesses: sidebarData.accesses,
			});
			setAccountDataStateRefresher(val => val + 1);

			navigate(HomeEnum.HOME_PAGE, {
				state: {
					isCommingFromEntryFlow: true,
				},
			});
		} catch (error) {
			removeAuthTokens();
			resetAccountData();
			setAccountDataStateRefresher(val => val + 1);
			navigate(SignInEnum.LOGIN, {
				replace: true,
				state: {
					b2bError: true,
				},
			});
		}
	};
	return {
		handleSetLoginToken,
	};
}
